module.exports = __webpack_public_path__ + "static/single-sign-on-cfa7473b66e04b30604888624049012f.png";